/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_SubtitleInputs */

const en_wc_on_subtitle = /** @type {(inputs: Wc_On_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open WordCraft in one click, with multilingual fonts included. No install and no sign-up, just a modern browser.`)
};

/**
* | output |
* | --- |
* | "Open WordCraft in one click, with multilingual fonts included. No install and no sign-up, just a modern browser." |
*
* @param {Wc_On_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_subtitle = /** @type {((inputs?: Wc_On_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_subtitle(inputs)
});
export { wc_on_subtitle as "wc.on.subtitle" }